import React from "react";
 
import AllServices from "./AllServices";
import AboutSection from "./AboutSection";
import DigitalTransformation from "./DigitalTransformation";
import Technology from "./Technology";
import Industries from "./Industries";
 
import { Helmet } from "react-helmet-async";

const Home = () => {
  return (
    <>

    <Helmet>
        {/* Primary SEO */}
        <title>
          Affsoft IT Solutions Pvt. Ltd. | Software Development, Web Design & IT Services
        </title>

        <meta
          name="title"
          content="Affsoft IT Solutions Pvt. Ltd. | Software Development, Web Design & IT Services"
        />

        <meta
          name="description"
          content="Affsoft IT Solutions Pvt. Ltd. provides innovative software development, web design, web development, mobile app development, SAP, Oracle, Power BI, cloud solutions, enterprise applications, AI solutions, and digital transformation services to help businesses grow."
        />

        <meta
          name="keywords"
          content="Affsoft IT Solutions Pvt. Ltd., Affsoft, IT Company, Software Development Company, Web Design Company, Web Development Company, Mobile App Development, React JS Development, Node JS Development, MERN Stack Development, Enterprise Applications, SAP Solutions, Oracle Solutions, Power BI Development, Cloud Solutions, AI Solutions, UI UX Design, Digital Transformation, API Development, Full Stack Development, Website Maintenance"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Affsoft IT Solutions Pvt. Ltd." />
        <meta name="language" content="English" />
        <meta name="theme-color" content="#0d5c53" />

        {/* Canonical */}
        <link rel="canonical" href="https://www.affsoft.com/" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Affsoft IT Solutions Pvt. Ltd." />
        <meta
          property="og:title"
          content="Affsoft IT Solutions Pvt. Ltd. | Innovative IT Solutions"
        />
        <meta
          property="og:description"
          content="Delivering web development, mobile applications, enterprise software, SAP, Oracle, Power BI, AI solutions, cloud services, and digital transformation for businesses worldwide."
        />
        <meta property="og:url" content="https://www.affsoft.com/" />
        <meta
          property="og:image"
          content="./images/affsoft-logo.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Affsoft IT Solutions Pvt. Ltd. | Software Development & IT Services"
        />
        <meta
          name="twitter:description"
          content="Transform your business with Affsoft's software development, web design, mobile applications, enterprise solutions, SAP, Oracle, Power BI, AI, and cloud services."
        />
        <meta
          name="twitter:image"
          content="https://www.affsoft.com/images/og-image.jpg"
        />
      </Helmet>

    <section className="hero-section">

      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="video-bg"
      >
        <source src="/video/affsoft-home.mp4" type="video/mp4" />
        Affsoft IT Solutions Pvt. Ltd.
      </video>

      {/* Dark Overlay */}
      <div className="overlay"></div>

      {/* Hero Content */}

      <div className="grid-overlay position-absolute top-0 start-0 w-100 h-100">
    <div className="grid-line line-v-1"></div>
    <div className="grid-line line-v-2"></div>
    <div className="grid-line line-v-3"></div>
    {/* <div className="grid-line line-v-4"></div>  */}
  </div>
      <div className="container">
        <div className="hero-content text-center">

          <p>Welcome to </p>

          <h5>Affsoft IT Solutions Pvt. Ltd.</h5>

          <h1>
            Continue your quest for  <br />
            <span> limitless possibilities with our disruptive innovation</span>
          </h1>

          <p>
            Your Partners in Building the Exceptional
          </p>

          <button className="hero-btn">
           Let's Talk →
          </button>

        </div>
      </div>

    </section>

     

    <AboutSection />


    <AllServices />

    <DigitalTransformation />

    <Technology />

    <Industries />
    </>
  );
};

export default Home;